import type { ReactNode } from "react";

interface CardProps {
  title?: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  onClick?: () => void;
  children?: ReactNode;
}

export function Card({ title, description, icon, onClick, children }: CardProps) {
  const classes = ["card"];
  if (onClick) classes.push("clickable");
  return (
    <div
      className={classes.join(" ")}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {icon && <div className="icon-wrap">{icon}</div>}
      {title && <h3>{title}</h3>}
      {description && <p>{description}</p>}
      {children}
    </div>
  );
}
